<template lang="pug">
EcreativArchetypesInteractiveArchetype.collapseButton.pe-4(
  v-toggle-collapse="toggleId"
  v-bind="{ componentType, context, isUnderLine, size, hoverColor, fontWeight, text, linkColor}"
  :class="{ 'isFirstControl': isControl }"
)
  template(v-if="hasIcon" #icon)
    EcreativAtomsSvgIcon(
      v-bind="{ iconName, isCustom, context: iconContext, iconSize }"
    )
</template>

<script setup lang="ts">
/* eslint-disable */
import { computed } from 'vue';
import {
  type InteractiveArchetype,
  defaultInteractiveArchetype,
} from 'data-types-config';
import EcreativAtomsSvgIcon from '../atoms/SvgIcon.vue';
import EcreativArchetypesInteractiveArchetype from '../archetypes/InteractiveArchetype';

const props = withDefaults(
  defineProps<
    Partial<InteractiveArchetype> & {
      collapsePrefix: string;
      hasIcon?: boolean;
      isControl?: boolean;
      collapseId?: number;
      iconName?: string;
      isCustom?: boolean;
      iconContext?: string;
      iconSize?: string;
    }
  >(),
  {
    ...defaultInteractiveArchetype,
    context: 'none' as const,
    hasIcon: true,
    isUnderLine: 'underline' as const,
    size: 'sm' as const,
    componentType: 'Button' as const,
    hoverColor: 'var:primary',
    isControl: true,
    collapseId: 0,
    fontWeight: 'bold' as const,
    iconName: 'chevronDown',
    isCustom: true,
    iconContext: 'white' as const,
    iconSize: 'sm' as const,
    collapsePrefix: '',
  },
);

const toggleId = computed(() => {
  return `${props.collapsePrefix}-${props.collapseId}`;
});
</script>

<style lang="scss">
.collapseButton {
  position: relative;

  .iconWrapper {
    position: absolute;
    top: 50%;
    right: 0;
    transition: all 0.15s ease 0s;
    transform: translateY(-50%) rotate(0deg);
  }

  &[aria-expanded='true'] {
    .iconWrapper {
      color: $secondary;
      transform: translateY(-50%) rotate(180deg);
    }
  }

  &:not(.isFirstControl)[aria-expanded='true'] {
    color: transparent;
    visibility: hidden;
    pointer-events: none;
  }
}
</style>
